module.exports = __webpack_public_path__ + "media/svg/selection_fond_en_2-95c16166.svg";